import { FilePlus2, FolderOpen } from 'lucide-react';

import { APP_VERSION } from '@/content/copy';

interface RecoveryScreenProps {
  readonly draft: { readonly name: string; readonly updatedAt: string };
  readonly onContinue: () => void;
  readonly onNew: () => Promise<void>;
}

export function RecoveryScreen({ draft, onContinue, onNew }: RecoveryScreenProps) {
  return (
    <div className="setup-screen recovery-screen">
      <header className="setup-topbar">
        <div className="setup-brand">
          <img src="/assets/icons/icon-192.png" alt="DG embalajes" />
          <div>
            <strong>DG embalajes</strong>
            <span>{APP_VERSION}</span>
          </div>
        </div>
      </header>
      <main className="recovery-main" aria-labelledby="recovery-title">
        <div className="recovery-copy">
          <span className="recovery-eyebrow">Borrador guardado en este dispositivo</span>
          <h1 id="recovery-title">Tu diseño está listo para continuar</h1>
          <p><strong>{draft.name}</strong> quedó conservado completo. Podés retomarlo o comenzar otro sin borrar el anterior.</p>
        </div>
        <div className="recovery-actions">
          <button className="primary-action" type="button" onClick={onContinue}>
            <FolderOpen aria-hidden="true" /> Continuar borrador
          </button>
          <button className="secondary-action" type="button" onClick={() => void onNew()}>
            <FilePlus2 aria-hidden="true" /> Nuevo diseño
          </button>
        </div>
      </main>
    </div>
  );
}
